export default __webpack_public_path__ + "static/media/alona-main.0ace66d0.jpg";